import { render, staticRenderFns } from "./TableGameGroups.vue?vue&type=template&id=095511d0&scoped=true"
import script from "./TableGameGroups.js?vue&type=script&lang=js&external"
export * from "./TableGameGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095511d0",
  null
  
)

export default component.exports